module.exports = __webpack_public_path__ + "img/default-avatar.4be3c0d1.png";